import React from "react";
import { Container } from "reactstrap";

/**
 * Shown after a real, successful sign-in when User.mcapAccess is false.
 *
 * Deliberately not a redirect to /login — that would look like the sign-in
 * itself failed, which it didn't. The account is real, the password was
 * right; what's missing is a grant only an admin who already has MCAP can
 * hand out from Admin Access in the console (Neo-Admin-web), one teammate
 * at a time.
 */
const NotGranted = ({ onSignOut }) => (
    <div className="d-flex align-items-center justify-content-center vh-100">
        <Container style={{ maxWidth: 460 }} className="text-center">
            <h4 className="mb-3">MCAP access not granted</h4>
            <p className="text-muted mb-4">
                Your sign-in worked, but this account hasn&apos;t been given access to MCAP yet. Ask an administrator
                who already has access to grant it to you from Admin Access in the console — it takes effect the
                next time you sign in here.
            </p>
            <button type="button" className="btn btn-primary" onClick={onSignOut}>
                Sign out
            </button>
        </Container>
    </div>
);

export default NotGranted;
